export const getItem = (name: any) => window.localStorage.getItem(name) ?? false

export const setItem = (name: any, value: any) => window.localStorage.setItem(name, value)

export const removeItem = (name: any) => getItem(name) && window.localStorage.removeItem(name)
